import { useState } from 'react';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../../../../components/Dialog';
import Text from '../../../../../../components/Text';
import { Checkbox } from '../../../../../DutyAssign/components/Attendance/Setting';

const SelectSpecialties = ({ handleClose, existingCode, handleUpdate }) => {
  const [form, setForm] = useState({
    applyFollowingUpdate: [],
    followingExistingSpecialties: [],
  });

  const followChangeList = [
    {
      text: 'Additional Remark Template @ Emergency Admission Form',
      value: 1,
    },
    {
      text: 'Ward Assignment By',
      value: 2,
    },
    {
      text: 'Redirection Option @Ward Ack.',
      value: 3,
    },
  ];

  const handleSelectChanges = (value) => () => {
    setForm((o) => ({
      ...o,
      applyFollowingUpdate: _.some(o.applyFollowingUpdate, (item) => item === value)
        ? _.filter(o.applyFollowingUpdate, (item) => item !== value)
        : [...o.applyFollowingUpdate, value],
    }));
  };

  const handleSelectExisting = (value) => () => {
    setForm((o) => ({
      ...o,
      followingExistingSpecialties: _.some(o.followingExistingSpecialties, (item) => item === value)
        ? _.filter(o.followingExistingSpecialties, (item) => item !== value)
        : [...o.followingExistingSpecialties, value],
    }));
  };

  const handleConfirm = () => {
    handleUpdate(form);
  };

  return (
    <Dialog
      open={true}
      title="Select Specialties For Batch Update"
      cancel="Cancel"
      confirm="Update"
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      confirmStyle={{ backgroundColor: '#28D2AB' }}
      dialogfootStyle={{ paddingTop: '1.875rem', boxShadow: '0px -1px 0px 0px #E4E7EB', marginTop: '2.5rem' }}
    >
      <Text color="#2E4469" fontSize="1rem">
        Apply Following Changes:
      </Text>
      <Box display="flex" flexDirection="column" mt="1.62rem" mb="2.5rem" gridGap="1.25rem">
        {followChangeList.map((item) => (
          <Box display="flex" gridGap="0.75rem" key={item.value}>
            <Checkbox
              check={_.some(form.applyFollowingUpdate, (formItem) => formItem === item.value)}
              handleChange={handleSelectChanges(item.value)}
            />
            <Text color="#2E4469" fontSize="1rem">
              {item.text}
            </Text>
          </Box>
        ))}
      </Box>
      <Text color="#2E4469" fontSize="1rem">
        To Following Existing Specialties:
      </Text>
      <Box display="flex" flexDirection="column" mt="1.63rem" gridGap="1.25rem">
        {existingCode.map((item) => (
          <Box display="flex" gridGap="0.75rem" key={item}>
            <Checkbox
              check={_.some(form.followingExistingSpecialties, (formItem) => formItem === item)}
              handleChange={handleSelectExisting(item)}
            />
            <Text color="#2E4469" fontSize="1rem">
              {item}
            </Text>
          </Box>
        ))}
      </Box>
    </Dialog>
  );
};

export default SelectSpecialties;
